module.exports = __webpack_public_path__ + "static/media/LabUniverse.27429d29.png";